"use client";

/**
 * `HeroAppWindow` — desktop frame around {@link HeroProductWindow}. The window
 * floats on a radially fading dot grid, carries a hairline ring and flat light
 * chrome behind its translucent top bar. `.mkhero-brand` re-enables verdigris
 * inside: the product UI keeps the brand accent while the marketing page around
 * it stays black and white.
 */
import type { ReactNode } from "react";

import { MARKETING_PRODUCT_WINDOW_LABEL } from "@/lib/marketing-seo";
import { DotGridBackdrop } from "../../dot-grid-backdrop";
import { WINDOW_CHROME_BG, WINDOW_RING } from "../hero-tokens";
import {
  HeroProductWindow,
  type HeroProductWindowProps,
} from "./hero-product-window";

/** On-screen width of the product window. */
const WINDOW_MAX_WIDTH = 1124;

export function HeroAppWindow(props: HeroProductWindowProps): ReactNode {
  return (
    <section
      aria-label={MARKETING_PRODUCT_WINDOW_LABEL}
      style={{ position: "relative", marginTop: 64, padding: "0 28px" }}
    >
      {/* Dot grid behind the window, bleeding into the gaps above and below. */}
      <DotGridBackdrop
        tone="light"
        focus="center"
        style={{ top: -84, bottom: -64 }}
      />
      <div
        className="mkhero-brand"
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: WINDOW_MAX_WIDTH,
          margin: "0 auto",
          borderRadius: 16,
          background: WINDOW_CHROME_BG,
          boxShadow: WINDOW_RING,
        }}
      >
        <HeroProductWindow {...props} />
      </div>
    </section>
  );
}
